// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Calendar-module__Container__aEttE {
    display: grid;
    gap: var(--ds-2x);
    width: 100%;
    border-collapse: collapse;
}

.Calendar-module__WeekDaysHeader__cuCNO {
    position: relative;
    display: flex;
    gap: var(--ds-05x);
}

.Calendar-module__WeekDaysHeader__cuCNO::after {
    position: absolute;
    bottom: calc(var(--ds-05x) * -1);
    width: 100%;
    border: 1px solid var(--ds-week-days-header-border-color);
    content: '';
}

.Calendar-module__WeekDay__tj9qs {
    display: flex;
    flex-basis: var(--ds-10x);
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    min-width: var(--ds-10x);
    height: var(--ds-10x);
    color: var(--ds-calendar-weekday-text-color);
    /* stylelint-disable-next-line property-disallowed-list, declaration-property-value-disallowed-list -- DS */
    font-weight: var(--ds-font-weight-bold);
    /* stylelint-disable-next-line property-disallowed-list -- DS */
    font-size: var(--ds-text-small);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Calendar-module__Container__aEttE`,
	"WeekDaysHeader": `Calendar-module__WeekDaysHeader__cuCNO`,
	"WeekDay": `Calendar-module__WeekDay__tj9qs`
};
export default ___CSS_LOADER_EXPORT___;
